import { Typography } from "@mui/material";
import NotificationIcon from "../../components/icons/NotificationIcon";

export default function EmptyNotification() {
    return (
        <div className="flex flex-col items-center justify-center" style={{ textAlign: 'center', marginTop: '130px' }}>
            <NotificationIcon className="mt-10 text-[var(--primary-text-color)]" />
            <Typography className=" !mt-12 text-[var(--primary-text-color)]">
                اطلاعیه ای برای شما  <span className="text-[#BBA57A]">  ارسال نشده</span> است.

            </Typography>
        </div>
    )
}
